import React from 'react';

export const VolEventCountryModal = {
  title: 'Country',
  body: (
    <div>
      <p>
        The Country where the volcano is located.
      </p>
    </div>
  ),
};
